var map = {
	"./banner.jpg": "49f2",
	"./banner_en.jpg": "de1a",
	"./banner_es.jpg": "dafe",
	"./banner_hk.jpg": "a360",
	"./banner_pt.jpg": "5a24",
	"./banner_tr.jpg": "6111"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "475d";